var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "page-editor-ui": "static-1.34249",
      "apollo-dlb": "static-3.41",
      "backbone": "static-1.6",
      "client-types": "static-1.384",
      "codemirror-dlb": "static-1.54912",
      "collaboration-sidebar": "static-1.54109",
      "ContentComponents": "static-2.67510",
      "ContentData": "static-1.64629",
      "ContentEditorUI": "static-2.73355",
      "ContentUtils": "static-1.64553",
      "customer-agent-discovery-components-lib": "static-1.1064",
      "data-fetching-client": "static-1.8693",
      "editor-components": "static-1.12067",
      "emoji-mart": "static-3.4",
      "FileManagerLib": "static-1.35570",
      "foundations-assets": "static-1.3956",
      "foundations-components": "static-1.6396",
      "head-dlb": "static-1.4210",
      "hs-test-utils": "static-1.7052",
      "hub-http": "static-1.4807",
      "hub-http-shared-msw-handlers": "static-1.7414",
      "hubspot-dlb": "static-2.1406",
      "HubStyleTokens": "static-2.10572",
      "I18n": "static-7.1404",
      "InpageEditorUI": "static-1.81795",
      "jasmine-immutable": "static-1.2019",
      "jasmine-runner": "static-1.5475",
      "layout-dnd-utils": "static-1.9965",
      "personalization-lib": "static-1.3505",
      "quartz": "static-1.5811",
      "react-dlb": "static-1.55",
      "react-dnd": "static-4.51",
      "react-dnd-html5-backend": "static-4.5",
      "react-redux": "static-7.16",
      "react-router-dom": "static-5.26",
      "react-utils": "static-2.4520",
      "redux-thunk": "static-2.43",
      "settings-ui-lib": "static-1.11587",
      "sinon": "static-1.9",
      "tinymce": "static-6.5",
      "ui-addon-draggable": "static-1.4368",
      "ui-components-test-utils": "static-1.4710",
      "ui-images": "static-2.898",
      "ui-memberships-settings-lib": "static-1.30129",
      "video-components-external": "static-1.7419",
      "webpack-env": "static-1.54",
      "ai-components-ui-library": "static-1.5645",
      "apollo-stack-hubspot": "static-3.43",
      "asset-actions-lib": "static-1.41714",
      "atom": "static-1.4206",
      "blueimp-md5": "static-1.8",
      "campaigns-lib": "static-1.23626",
      "classnames": "static-2.10",
      "content-assistance-lib": "static-1.6629",
      "content-management-actions-lib": "static-1.23988",
      "content-management-data-lib": "static-1.4186",
      "content-management-restrictions-lib": "static-1.3923",
      "copilot-plugins": "static-1.7688",
      "copilot-toolkit": "static-1.7715",
      "cropperjs": "static-1.10",
      "cssUtils": "static-1.537",
      "cta-picker": "static-1.33028",
      "customer-data-objects": "static-1.6670",
      "customer-data-objects-ui-components": "static-1.11962",
      "customer-data-properties": "static-1.47366",
      "customer-data-property-utils": "static-1.6991",
      "customer-data-reference-ui-components": "static-1.12070",
      "customer-data-ui-utilities": "static-1.8785",
      "data-token-picker": "static-1.14532",
      "data-token-views": "static-1.14513",
      "error-messaging-js": "static-1.4331",
      "feedback-loader": "static-1.27087",
      "file-manager-components": "static-1.19930",
      "FileManagerCore": "static-1.35429",
      "FormsCommonComponents": "static-1.82316",
      "foundations-theming": "static-1.3360",
      "fuzzy": "static-1.8",
      "growth-onboarding-beacon": "static-1.3442",
      "growth-onboarding-confetti": "static-1.2152",
      "growth-onboarding-next-action-components": "static-1.380",
      "growth-payments-core": "static-1.22208",
      "history": "static-4.47",
      "hs-lodash": "static-4.45",
      "hs-promise-utils": "static-1.4582",
      "hub-http-contrib": "static-1.2206",
      "hubspot-url-utils": "static-1.3063",
      "HubStyle": "static-2.10880",
      "icons": "static-2.592",
      "immer": "static-1.33",
      "immutable": "static-2.19",
      "InboxConnectUtils": "static-4.11287",
      "integrations-lib": "static-1.12096",
      "interframe": "static-3.3831",
      "laboratory-lib": "static-3.6280",
      "layout-data-lib": "static-1.8290",
      "media-bridge-lib": "static-1.17133",
      "nav-meta": "static-1.26146",
      "object-builder-ui-client": "static-1.44182",
      "onboarding-scopes": "static-1.5607",
      "onboarding-tours": "static-1.15000",
      "onboarding-tours-client": "static-1.3535",
      "outpost": "static-1.3410",
      "page-lib": "static-1.18193",
      "PatternValidationJS": "static-1.437",
      "payment-link-components": "static-1.20092",
      "payments-post-enroll-local-storage-lib": "static-1.4143",
      "pictos": "static-7.163",
      "PortalIdParser": "static-2.291",
      "products-ui-components": "static-1.36568",
      "property-translator": "static-1.4459",
      "quick-fetch": "static-1.2772",
      "raven": "static-3.5037",
      "react": "static-7.151",
      "react-beautiful-dnd": "static-1.13",
      "react-colorpicker": "static-2.9314",
      "react-dom": "static-7.85",
      "react-flip-move": "static-1.49",
      "react-immutable-proptypes": "static-2.8",
      "react-input-autosize": "static-2.17",
      "react-rhumb": "static-1.15616",
      "react-select-plus": "static-1.65",
      "react-tinymce": "static-1.51889",
      "react-transition-group": "static-1.7",
      "react-virtualized": "static-2.76",
      "redux": "static-4.16",
      "redux-request-state": "static-1.9645",
      "reference-resolvers": "static-1.7208",
      "reference-resolvers-lite": "static-1.7061",
      "reselect": "static-2.16",
      "rich-text-lib": "static-1.17888",
      "rpc-client-utils": "static-1.3791",
      "sanitize": "static-1.3433",
      "sanitize-text": "static-1.7206",
      "seamless-immutable": "static-7.6",
      "self-service-api": "static-1.9271",
      "SharedI18nStrings": "static-1.163",
      "SharedLegalStrings": "static-1.1322",
      "simple-menus-core": "static-1.13831",
      "simple-menus-lib": "static-1.15348",
      "smart-content-lib": "static-1.39520",
      "styled-components": "static-2.64",
      "StyleGuideUI": "static-3.468",
      "superstore": "static-1.3824",
      "theme-previewer-lib": "static-1.49705",
      "tinymce-config": "static-2.51015",
      "tinymce-copilot": "static-1.13083",
      "tinymce-data": "static-1.37100",
      "tinymce-plugins": "static-1.54129",
      "tinymce-themes": "static-1.52985",
      "transmute": "static-2.29",
      "ui-addon-avatars": "static-2.8159",
      "ui-addon-emoji-picker": "static-1.8993",
      "ui-addon-form-validation": "static-1.10080",
      "ui-addon-i18n": "static-1.9993",
      "ui-addon-iframeable": "static-1.7948",
      "ui-addon-opt": "static-4.7630",
      "ui-addon-sales-email": "static-1.4260",
      "ui-addon-upgrades": "static-9.16477",
      "ui-business-units-lib": "static-1.7965",
      "ui-gdpr-components": "static-1.9285",
      "ui-product-approvals": "static-1.24754",
      "ui-shepherd-react": "static-3.9116",
      "ui-suspension-banners-lib": "static-1.5463",
      "UIComponents": "static-3.7519",
      "underscore": "static-1.8",
      "urlinator": "static-1.3596",
      "usage-tracker": "static-1.6519",
      "usage-tracker-core": "static-1.6369",
      "user-context": "static-1.4253",
      "video-embed": "static-1.31911",
      "web-interactives-components": "static-1.11973",
      "web-interactives-data": "static-1.11974",
      "wootric-nps": "static-1.5928",
      "xray-recommendation-lib": "static-1.6442",
      "codemirror": "static-5.74",
      "react-codemirror": "static-1.9661",
      "enviro": "static-4.313",
      "hs-promise-rejection-tracking": "static-1.4568",
      "raven-hubspot": "static-1.5344",
      "hoist-non-react-statics": "static-3.9",
      "metrics-js": "static-1.8459",
      "bend-plugin-trellis-migration": "static-1.2658",
      "moment": "static-3.26",
      "jquery": "static-3.6",
      "chatspot-client-types": "static-1.9117",
      "chatspot-core": "static-1.17114",
      "chatspot-widget-iframe": "static-1.17107",
      "framework-data-schema-resolvers": "static-1.5931",
      "frontend-preferences-client": "static-1.6958",
      "graphql": "static-1.61",
      "magpie-lib": "static-1.4714",
      "magpie-types": "static-1.4174",
      "quartz-core": "static-1.5030",
      "simple-logging-lib": "static-1.2081",
      "ts-schema": "static-1.3310",
      "avatar-components": "static-1.1538",
      "cms-field-types": "static-1.3820",
      "content-embed-lib": "static-1.6393",
      "ExportDialog": "static-6.9455",
      "forms-utils-lib": "static-1.10727",
      "integrations-error-boundary-lib": "static-1.9511",
      "payments-embed-points-lib": "static-1.10454",
      "react-dnd-compat": "static-1.3722",
      "usage-tracker-container": "static-1.6509",
      "video-data-lib": "static-1.31076",
      "videoconference-integration-components": "static-1.5331",
      "editor-iframe-lib": "static-1.7384",
      "FireAlarmUi": "static-1.3801",
      "hubspot-apollo-client": "static-1.3879",
      "layout-dnd-components": "static-1.10990",
      "marketing-email-service-types": "static-1.1495",
      "smart-content-core": "static-1.38867",
      "social-composer-lib": "static-1.54770",
      "structured-content-lib": "static-1.21769",
      "timezone-utils": "static-2.4278",
      "ui-active-theme-content-creator-lib": "static-1.34175",
      "ui-addon-video-player": "static-1.7842",
      "ui-asset-management-lib": "static-1.9490",
      "ui-brand-identity-lib": "static-1.10204",
      "ui-tool-access": "static-1.9129",
      "content-icons-ui": "static-1.1949",
      "event-emitter": "static-1.52",
      "fast-json-stable-stringify": "static-1.4",
      "react-aria": "static-1.41",
      "audio-components": "static-1.4770",
      "FileManagerImages": "static-1.33081",
      "video-components": "static-1.9422",
      "hs-story-utils": "static-1.8420",
      "bend-plugin-foundations-components": "static-1.2665",
      "floating-ui": "static-1.31",
      "foundations-theming-specialty": "static-1.1077",
      "framer-motion": "static-1.43",
      "tanstack-table": "static-1.23",
      "ui-fonts": "static-1.332",
      "HeadJS": "static-2.587",
      "hs-test-utils-bend-plugin": "static-1.2163",
      "msw": "static-1.39",
      "testing-library": "static-1.125",
      "i18n-data": "static-1.200",
      "moment-timezone": "static-5.51",
      "NamespacedHubStyle": "static-2.8399",
      "react-dnd-ipeui-backend": "static-1.1119",
      "ui-coaching-tips": "static-1.24609",
      "jasmine": "static-4.3404",
      "marketplace-embed": "static-1.18388",
      "quartz-core-utils": "static-1.2678",
      "flux-actions": "static-1.280",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.9520",
      "rxjs": "static-5.10",
      "foundations-components-test-utils": "static-1.3880",
      "apollo-link-hub-http": "static-2.3832",
      "content-media-compositions": "static-2.11704",
      "idb-keyval": "static-1.23",
      "immerable": "static-1.3191",
      "autolinker": "static-3.11",
      "foundations-theming-base": "static-1.2345",
      "sassPrefix": "static-1.134",
      "marketing-platform-lib": "static-1.5738",
      "attribution-lib": "static-1.39015",
      "campaigns-build-lib": "static-1.9679",
      "crm-pipelines-api-client-types": "static-1.3289",
      "reporting-ui-components": "static-2.60324",
      "ai-rendering-library": "static-1.6413",
      "calling-cross-tab-library": "static-1.18272",
      "calling-global-api": "static-1.59748",
      "calling-internal-common": "static-1.30289",
      "calling-integration-cross-tab": "static-1.19264",
      "calling-lifecycle-internal": "static-1.61130",
      "calling-lifecycle-messages": "static-1.53425",
      "commerce-products-lib": "static-1.6048",
      "conditional-properties-service-client": "static-1.3099",
      "crm-links": "static-1.5149",
      "crm-message-bus": "static-1.38654",
      "external-options-client-types": "static-1.3312",
      "google-libphonenumber": "static-1.14",
      "inbound-db-meta-service-client": "static-1.2971",
      "inbound-db-properties-service-client": "static-1.3149",
      "inbounddb-objects-service-types": "static-1.3409",
      "pipeline-validation-client-types": "static-1.3103",
      "smart-property-lib": "static-1.2282",
      "react-immutable-render-mixin": "static-1.9",
      "redux-toolkit": "static-1.7",
      "salesImages": "static-1.503",
      "forms-ai-lib": "static-1.2576",
      "bend-plugin-foundations-theming": "static-1.1843",
      "embedded-academy-lib": "static-1.11132",
      "growth-onboarding-feedback-components": "static-1.5523",
      "ui-addon-react-router-dom": "static-1.8657",
      "commerce-analytics-service-client": "static-1.2769",
      "integrations-tracking-lib": "static-1.4610",
      "native-integrations-shared-strings": "static-1.6881",
      "getting-started-shared-tasks": "static-1.14498",
      "growth-data-modal": "static-1.4311",
      "growth-onboarding-next-action-utils": "static-1.352",
      "navigation-components": "static-1.14509",
      "ui-shepherd-tracker": "static-1.6497",
      "ui-universal-auth": "static-1.7880",
      "commerce-tours-lib": "static-1.4331",
      "growth-onboarding-reliability": "static-1.4200",
      "sales-checkout-service-client": "static-1.2781",
      "commerce-shared-components-lib": "static-1.15711",
      "commerce-subscription-lib": "static-1.33190",
      "crm_components": "static-3.87960",
      "crm_data": "static-4.87960",
      "customer-data-filters-ui": "static-1.35320",
      "customer-data-tracking": "static-1.5894",
      "dispatcher": "static-1.115",
      "framework-data-table": "static-2.9331",
      "property-description-translator": "static-1.2912",
      "csstype": "static-1.38",
      "batch-promise": "static-1.647",
      "commerce-tools-ui-lib": "static-1.7729",
      "redux-mock-store": "static-1.8",
      "redux-undo": "static-1.10",
      "hubspotter-http": "static-1.3785",
      "navigation-messaging": "static-1.3836",
      "feature-store-service-types": "static-1.3759",
      "growth-monetization-service-types": "static-1.3766",
      "upgrade-management-service-types": "static-1.3750",
      "getting-started-shared-tasks-store": "static-1.13616",
      "seo-tools-lib": "static-1.5439",
      "diff-match-patch": "static-1.7",
      "browser-eslint": "static-2.57",
      "framework-builder-read-service-client": "static-1.3257",
      "framework-data-schema-quick-fetch": "static-1.5836",
      "persist-promise": "static-1.2805",
      "hub-http-janus": "static-1.660",
      "general-store": "static-6.20",
      "hubspotter-http-shared-msw-handlers": "static-1.7412",
      "mobile-manifest-mixins": "static-1.358",
      "platform-navigation-bootstrap": "static-1.11477",
      "payments-enrollment-embed-lib": "static-1.18929",
      "social-insights-client-types": "static-1.18609",
      "marketplace-ui-apps-core": "static-1.14404",
      "marketplace-ui-client-types": "static-1.13276",
      "marketplace-ui-common": "static-1.15869",
      "marketplace-ui-details": "static-1.5767",
      "property-management-iframe": "static-1.9389",
      "trellis-ecosystem": "static-1.5252",
      "FormUrlGenerator": "static-2.3770",
      "highcharts": "static-8.83",
      "report-customization-components": "static-1.9963",
      "reporting-action-components": "static-1.37715",
      "reporting-data": "static-1.63048",
      "reporting-enablement": "static-1.18692",
      "reporting-snowflake": "static-1.51668",
      "reporting-visualizations": "static-1.55125",
      "reporting-plugins": "static-1.7926",
      "reporting-reports": "static-1.62730",
      "customer-data-filters": "static-1.49135",
      "highlight.js": "static-1.45",
      "markdown-it": "static-1.6",
      "react-table": "static-1.15",
      "ui-addon-teams": "static-1.20211",
      "shared-worker-versioning": "static-1.10119",
      "calling-error-reporting": "static-1.30295",
      "calling-usage-tracker": "static-1.5549",
      "worker-connection-library": "static-1.13717",
      "calling-orchestration-shared-library": "static-1.31618",
      "conversations-skeleton-state": "static-1.6420",
      "products-iframe-lib": "static-1.4514",
      "products-ui-components-shared-msw-handlers": "static-1.7797",
      "location-customization-utils-lib": "static-1.5257",
      "breeze-intelligence-kit": "static-1.4356",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.7498",
      "fsm": "static-1.2795",
      "policy-lib": "static-1.5835",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.7560",
      "final-form": "static-1.42",
      "academy-common-lib": "static-1.10592",
      "universal-page-editor-lib": "static-1.2023",
      "commerce-billing-lib": "static-1.15871",
      "commerce-contract-lib": "static-1.7885",
      "crm_universal": "static-1.20835",
      "customer-data-content": "static-1.25114",
      "crm_schema": "static-3.87999",
      "customer-data-email": "static-1.16184",
      "customer-data-filters-ui-msw-helpers": "static-1.17753",
      "lodash": "static-4.7",
      "customer-data-associations": "static-1.6255",
      "customer-data-rte": "static-1.30122",
      "cv-backend-services": "static-1.1250",
      "growth-onboarding-empty-states": "static-1.4403",
      "hubspot-prosemirror": "static-1.14842",
      "prosemirror": "static-1.13",
      "qrcode-generator": "static-1.46",
      "quotes-client-types": "static-1.33497",
      "trials-service-types": "static-1.3167",
      "platform-infra-nav-components": "static-1.6896",
      "stripe-embedded-components": "static-1.5692",
      "developer-experience-shared-components": "static-1.9306",
      "immutable-less": "static-1.3614",
      "ui-addon-integrations-directory-panel": "static-2.7080",
      "ui-extensibility-client-types": "static-1.3190",
      "ai-settings-ui-library": "static-1.6270",
      "react-window": "static-1.13",
      "ai-studio-lib": "static-1.7630",
      "marketplace-ui-reviews": "static-1.15827",
      "marketplace-ui-tracking": "static-1.10042",
      "usage-based-billing-components-lib": "static-1.5206",
      "property-management-common": "static-1.1675",
      "storybook-react": "static-1.6",
      "trellis-story-utils": "static-1.3608",
      "dashboard-lib": "static-1.77276",
      "share-with-third-party-component-lib": "static-1.7723",
      "reporting-client-types": "static-1.2077",
      "data-quality-ui-library": "static-1.9497",
      "html-to-image": "static-1.32",
      "reporting-datasets-permissions-lib": "static-1.9362",
      "crm-object-map": "static-1.2837",
      "campaign-roi-lib": "static-1.4836",
      "deep-diff": "static-1.5",
      "calling-orchestration-schema": "static-1.31843",
      "multi-currency-client-types": "static-1.2964",
      "sales-views-client-types": "static-1.3373",
      "crm-record-cards-service-types": "static-1.2927",
      "academy-service-client": "static-1.2692",
      "zustand": "static-1.51",
      "usage-tracker-session-replay": "static-1.4205",
      "utility-belt": "static-1.1592",
      "crm-cards-sdk": "static-1.39653",
      "SalesContentIndexUI": "static-3.7566",
      "sequences-lib": "static-1.6353",
      "draft-content-plugins": "static-1.25475",
      "draft-convert": "static-2.31",
      "draft-extend": "static-2.46",
      "draft-js": "static-5.37",
      "draft-plugins": "static-2.19731",
      "knowledge-content-types": "static-1.7818",
      "stripe-connect-js": "static-1.42",
      "apps-service-types": "static-1.3121",
      "oauth-service-types": "static-1.3347",
      "subscription-experience-data-types": "static-1.12104",
      "crm-component-utils": "static-1.35656",
      "redux-actions": "static-3.7",
      "crm-fe-perf": "static-1.22048",
      "crm-index-visualization-object-layout": "static-1.2041",
      "crm-object-search-query-utilities": "static-1.7016",
      "amplitude-session-replay-browser": "static-1.35",
      "crm-actions": "static-1.5139",
      "sales-templates-service-types-lib": "static-1.3365",
      "sequences-client-types-lib": "static-1.6210",
      "card-properties-lib": "static-1.40346",
      "customer-data-properties-shared-msw-handlers": "static-1.6742",
      "customer-data-sidebar": "static-2.42487",
      "enrichment-properties-lib": "static-1.11401",
      "card-payment-highlight-lib": "static-1.33422",
      "card-subscription-highlight-lib": "static-1.35613",
      "invoices-highlight-card-lib": "static-1.50857",
      "orders-highlight-card-lib": "static-1.18379",
      "products-highlight-card-lib": "static-1.14333",
      "project-storage": "static-1.3753",
      "quotes-highlight-card-lib": "static-1.67414",
      "crm-source-interpretation-lib": "static-1.4342",
      "accounting-integrations-ui-components": "static-1.5350",
      "invoices-iframe-lib": "static-1.52931",
      "invoices-ui-lib": "static-1.50873",
      "SafeStorage": "static-1.3445",
      "quotes-modal-lib": "static-1.98085",
      "quotes-ui-lib": "static-1.76128",
      "totals-ui-components": "static-1.20336",
      "commerce-totals-service-types": "static-1.3046"
    },
    "depPathPrefixes": {
      "page-editor-ui": "/page-editor-ui/static-1.34249",
      "apollo-dlb": "/apollo-dlb/static-3.41",
      "backbone": "/backbone/static-1.6",
      "client-types": "/client-types/static-1.384",
      "codemirror-dlb": "/codemirror-dlb/static-1.54912",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.54109",
      "ContentComponents": "/ContentComponents/static-2.67510",
      "ContentData": "/ContentData/static-1.64629",
      "ContentEditorUI": "/ContentEditorUI/static-2.73355",
      "ContentUtils": "/ContentUtils/static-1.64553",
      "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.1064",
      "data-fetching-client": "/data-fetching-client/static-1.8693",
      "editor-components": "/editor-components/static-1.12067",
      "emoji-mart": "/emoji-mart/static-3.4",
      "FileManagerLib": "/FileManagerLib/static-1.35570",
      "foundations-assets": "/foundations-assets/static-1.3956",
      "foundations-components": "/foundations-components/static-1.6396",
      "head-dlb": "/head-dlb/static-1.4210",
      "hs-test-utils": "/hs-test-utils/static-1.7052",
      "hub-http": "/hub-http/static-1.4807",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.7414",
      "hubspot-dlb": "/hubspot-dlb/static-2.1406",
      "HubStyleTokens": "/HubStyleTokens/static-2.10572",
      "I18n": "/I18n/static-7.1404",
      "InpageEditorUI": "/InpageEditorUI/static-1.81795",
      "jasmine-immutable": "/jasmine-immutable/static-1.2019",
      "jasmine-runner": "/jasmine-runner/static-1.5475",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.9965",
      "personalization-lib": "/personalization-lib/static-1.3505",
      "quartz": "/quartz/static-1.5811",
      "react-dlb": "/react-dlb/static-1.55",
      "react-dnd": "/react-dnd/static-4.51",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-4.5",
      "react-redux": "/react-redux/static-7.16",
      "react-router-dom": "/react-router-dom/static-5.26",
      "react-utils": "/react-utils/static-2.4520",
      "redux-thunk": "/redux-thunk/static-2.43",
      "settings-ui-lib": "/settings-ui-lib/static-1.11587",
      "sinon": "/sinon/static-1.9",
      "tinymce": "/tinymce/static-6.5",
      "ui-addon-draggable": "/ui-addon-draggable/static-1.4368",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.4710",
      "ui-images": "/ui-images/static-2.898",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.30129",
      "video-components-external": "/video-components-external/static-1.7419",
      "webpack-env": "/webpack-env/static-1.54",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.5645",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.43",
      "asset-actions-lib": "/asset-actions-lib/static-1.41714",
      "atom": "/atom/static-1.4206",
      "blueimp-md5": "/blueimp-md5/static-1.8",
      "campaigns-lib": "/campaigns-lib/static-1.23626",
      "classnames": "/classnames/static-2.10",
      "content-assistance-lib": "/content-assistance-lib/static-1.6629",
      "content-management-actions-lib": "/content-management-actions-lib/static-1.23988",
      "content-management-data-lib": "/content-management-data-lib/static-1.4186",
      "content-management-restrictions-lib": "/content-management-restrictions-lib/static-1.3923",
      "copilot-plugins": "/copilot-plugins/static-1.7688",
      "copilot-toolkit": "/copilot-toolkit/static-1.7715",
      "cropperjs": "/cropperjs/static-1.10",
      "cssUtils": "/cssUtils/static-1.537",
      "cta-picker": "/cta-picker/static-1.33028",
      "customer-data-objects": "/customer-data-objects/static-1.6670",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.11962",
      "customer-data-properties": "/customer-data-properties/static-1.47366",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.6991",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12070",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.8785",
      "data-token-picker": "/data-token-picker/static-1.14532",
      "data-token-views": "/data-token-views/static-1.14513",
      "error-messaging-js": "/error-messaging-js/static-1.4331",
      "feedback-loader": "/feedback-loader/static-1.27087",
      "file-manager-components": "/file-manager-components/static-1.19930",
      "FileManagerCore": "/FileManagerCore/static-1.35429",
      "FormsCommonComponents": "/FormsCommonComponents/static-1.82316",
      "foundations-theming": "/foundations-theming/static-1.3360",
      "fuzzy": "/fuzzy/static-1.8",
      "growth-onboarding-beacon": "/growth-onboarding-beacon/static-1.3442",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2152",
      "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.380",
      "growth-payments-core": "/growth-payments-core/static-1.22208",
      "history": "/history/static-4.47",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hs-promise-utils": "/hs-promise-utils/static-1.4582",
      "hub-http-contrib": "/hub-http-contrib/static-1.2206",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3063",
      "HubStyle": "/HubStyle/static-2.10880",
      "icons": "/icons/static-2.592",
      "immer": "/immer/static-1.33",
      "immutable": "/immutable/static-2.19",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.11287",
      "integrations-lib": "/integrations-lib/static-1.12096",
      "interframe": "/interframe/static-3.3831",
      "laboratory-lib": "/laboratory-lib/static-3.6280",
      "layout-data-lib": "/layout-data-lib/static-1.8290",
      "media-bridge-lib": "/media-bridge-lib/static-1.17133",
      "nav-meta": "/nav-meta/static-1.26146",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.44182",
      "onboarding-scopes": "/onboarding-scopes/static-1.5607",
      "onboarding-tours": "/onboarding-tours/static-1.15000",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.3535",
      "outpost": "/outpost/static-1.3410",
      "page-lib": "/page-lib/static-1.18193",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "payment-link-components": "/payment-link-components/static-1.20092",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4143",
      "pictos": "/pictos/static-7.163",
      "PortalIdParser": "/PortalIdParser/static-2.291",
      "products-ui-components": "/products-ui-components/static-1.36568",
      "property-translator": "/property-translator/static-1.4459",
      "quick-fetch": "/quick-fetch/static-1.2772",
      "raven": "/raven/static-3.5037",
      "react": "/react/static-7.151",
      "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
      "react-colorpicker": "/react-colorpicker/static-2.9314",
      "react-dom": "/react-dom/static-7.85",
      "react-flip-move": "/react-flip-move/static-1.49",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-rhumb": "/react-rhumb/static-1.15616",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-tinymce": "/react-tinymce/static-1.51889",
      "react-transition-group": "/react-transition-group/static-1.7",
      "react-virtualized": "/react-virtualized/static-2.76",
      "redux": "/redux/static-4.16",
      "redux-request-state": "/redux-request-state/static-1.9645",
      "reference-resolvers": "/reference-resolvers/static-1.7208",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7061",
      "reselect": "/reselect/static-2.16",
      "rich-text-lib": "/rich-text-lib/static-1.17888",
      "rpc-client-utils": "/rpc-client-utils/static-1.3791",
      "sanitize": "/sanitize/static-1.3433",
      "sanitize-text": "/sanitize-text/static-1.7206",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "self-service-api": "/self-service-api/static-1.9271",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.163",
      "SharedLegalStrings": "/SharedLegalStrings/static-1.1322",
      "simple-menus-core": "/simple-menus-core/static-1.13831",
      "simple-menus-lib": "/simple-menus-lib/static-1.15348",
      "smart-content-lib": "/smart-content-lib/static-1.39520",
      "styled-components": "/styled-components/static-2.64",
      "StyleGuideUI": "/StyleGuideUI/static-3.468",
      "superstore": "/superstore/static-1.3824",
      "theme-previewer-lib": "/theme-previewer-lib/static-1.49705",
      "tinymce-config": "/tinymce-config/static-2.51015",
      "tinymce-copilot": "/tinymce-copilot/static-1.13083",
      "tinymce-data": "/tinymce-data/static-1.37100",
      "tinymce-plugins": "/tinymce-plugins/static-1.54129",
      "tinymce-themes": "/tinymce-themes/static-1.52985",
      "transmute": "/transmute/static-2.29",
      "ui-addon-avatars": "/ui-addon-avatars/static-2.8159",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.8993",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10080",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.9993",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.7948",
      "ui-addon-opt": "/ui-addon-opt/static-4.7630",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4260",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.16477",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.7965",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.9285",
      "ui-product-approvals": "/ui-product-approvals/static-1.24754",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.9116",
      "ui-suspension-banners-lib": "/ui-suspension-banners-lib/static-1.5463",
      "UIComponents": "/UIComponents/static-3.7519",
      "underscore": "/underscore/static-1.8",
      "urlinator": "/urlinator/static-1.3596",
      "usage-tracker": "/usage-tracker/static-1.6519",
      "usage-tracker-core": "/usage-tracker-core/static-1.6369",
      "user-context": "/user-context/static-1.4253",
      "video-embed": "/video-embed/static-1.31911",
      "web-interactives-components": "/web-interactives-components/static-1.11973",
      "web-interactives-data": "/web-interactives-data/static-1.11974",
      "wootric-nps": "/wootric-nps/static-1.5928",
      "xray-recommendation-lib": "/xray-recommendation-lib/static-1.6442",
      "codemirror": "/codemirror/static-5.74",
      "react-codemirror": "/react-codemirror/static-1.9661",
      "enviro": "/enviro/static-4.313",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4568",
      "raven-hubspot": "/raven-hubspot/static-1.5344",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "metrics-js": "/metrics-js/static-1.8459",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2658",
      "moment": "/moment/static-3.26",
      "jquery": "/jquery/static-3.6",
      "chatspot-client-types": "/chatspot-client-types/static-1.9117",
      "chatspot-core": "/chatspot-core/static-1.17114",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.17107",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.5931",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.6958",
      "graphql": "/graphql/static-1.61",
      "magpie-lib": "/magpie-lib/static-1.4714",
      "magpie-types": "/magpie-types/static-1.4174",
      "quartz-core": "/quartz-core/static-1.5030",
      "simple-logging-lib": "/simple-logging-lib/static-1.2081",
      "ts-schema": "/ts-schema/static-1.3310",
      "avatar-components": "/avatar-components/static-1.1538",
      "cms-field-types": "/cms-field-types/static-1.3820",
      "content-embed-lib": "/content-embed-lib/static-1.6393",
      "ExportDialog": "/ExportDialog/static-6.9455",
      "forms-utils-lib": "/forms-utils-lib/static-1.10727",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.9511",
      "payments-embed-points-lib": "/payments-embed-points-lib/static-1.10454",
      "react-dnd-compat": "/react-dnd-compat/static-1.3722",
      "usage-tracker-container": "/usage-tracker-container/static-1.6509",
      "video-data-lib": "/video-data-lib/static-1.31076",
      "videoconference-integration-components": "/videoconference-integration-components/static-1.5331",
      "editor-iframe-lib": "/editor-iframe-lib/static-1.7384",
      "FireAlarmUi": "/FireAlarmUi/static-1.3801",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.3879",
      "layout-dnd-components": "/layout-dnd-components/static-1.10990",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.1495",
      "smart-content-core": "/smart-content-core/static-1.38867",
      "social-composer-lib": "/social-composer-lib/static-1.54770",
      "structured-content-lib": "/structured-content-lib/static-1.21769",
      "timezone-utils": "/timezone-utils/static-2.4278",
      "ui-active-theme-content-creator-lib": "/ui-active-theme-content-creator-lib/static-1.34175",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.7842",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.9490",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.10204",
      "ui-tool-access": "/ui-tool-access/static-1.9129",
      "content-icons-ui": "/content-icons-ui/static-1.1949",
      "event-emitter": "/event-emitter/static-1.52",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "react-aria": "/react-aria/static-1.41",
      "audio-components": "/audio-components/static-1.4770",
      "FileManagerImages": "/FileManagerImages/static-1.33081",
      "video-components": "/video-components/static-1.9422",
      "hs-story-utils": "/hs-story-utils/static-1.8420",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.2665",
      "floating-ui": "/floating-ui/static-1.31",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1077",
      "framer-motion": "/framer-motion/static-1.43",
      "tanstack-table": "/tanstack-table/static-1.23",
      "ui-fonts": "/ui-fonts/static-1.332",
      "HeadJS": "/HeadJS/static-2.587",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2163",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.125",
      "i18n-data": "/i18n-data/static-1.200",
      "moment-timezone": "/moment-timezone/static-5.51",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8399",
      "react-dnd-ipeui-backend": "/react-dnd-ipeui-backend/static-1.1119",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.24609",
      "jasmine": "/jasmine/static-4.3404",
      "marketplace-embed": "/marketplace-embed/static-1.18388",
      "quartz-core-utils": "/quartz-core-utils/static-1.2678",
      "flux-actions": "/flux-actions/static-1.280",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.9520",
      "rxjs": "/rxjs/static-5.10",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.3880",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.3832",
      "content-media-compositions": "/content-media-compositions/static-2.11704",
      "idb-keyval": "/idb-keyval/static-1.23",
      "immerable": "/immerable/static-1.3191",
      "autolinker": "/autolinker/static-3.11",
      "foundations-theming-base": "/foundations-theming-base/static-1.2345",
      "sassPrefix": "/sassPrefix/static-1.134",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.5738",
      "attribution-lib": "/attribution-lib/static-1.39015",
      "campaigns-build-lib": "/campaigns-build-lib/static-1.9679",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3289",
      "reporting-ui-components": "/reporting-ui-components/static-2.60324",
      "ai-rendering-library": "/ai-rendering-library/static-1.6413",
      "calling-cross-tab-library": "/calling-cross-tab-library/static-1.18272",
      "calling-global-api": "/calling-global-api/static-1.59748",
      "calling-internal-common": "/calling-internal-common/static-1.30289",
      "calling-integration-cross-tab": "/calling-integration-cross-tab/static-1.19264",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.61130",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.53425",
      "commerce-products-lib": "/commerce-products-lib/static-1.6048",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3099",
      "crm-links": "/crm-links/static-1.5149",
      "crm-message-bus": "/crm-message-bus/static-1.38654",
      "external-options-client-types": "/external-options-client-types/static-1.3312",
      "google-libphonenumber": "/google-libphonenumber/static-1.14",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.2971",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3149",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3409",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3103",
      "smart-property-lib": "/smart-property-lib/static-1.2282",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "salesImages": "/salesImages/static-1.503",
      "forms-ai-lib": "/forms-ai-lib/static-1.2576",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.1843",
      "embedded-academy-lib": "/embedded-academy-lib/static-1.11132",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.5523",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.8657",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.2769",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.4610",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.6881",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.14498",
      "growth-data-modal": "/growth-data-modal/static-1.4311",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.352",
      "navigation-components": "/navigation-components/static-1.14509",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.6497",
      "ui-universal-auth": "/ui-universal-auth/static-1.7880",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.4331",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4200",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.2781",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.15711",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.33190",
      "crm_components": "/crm_components/static-3.87960",
      "crm_data": "/crm_data/static-4.87960",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.35320",
      "customer-data-tracking": "/customer-data-tracking/static-1.5894",
      "dispatcher": "/dispatcher/static-1.115",
      "framework-data-table": "/framework-data-table/static-2.9331",
      "property-description-translator": "/property-description-translator/static-1.2912",
      "csstype": "/csstype/static-1.38",
      "batch-promise": "/batch-promise/static-1.647",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.7729",
      "redux-mock-store": "/redux-mock-store/static-1.8",
      "redux-undo": "/redux-undo/static-1.10",
      "hubspotter-http": "/hubspotter-http/static-1.3785",
      "navigation-messaging": "/navigation-messaging/static-1.3836",
      "feature-store-service-types": "/feature-store-service-types/static-1.3759",
      "growth-monetization-service-types": "/growth-monetization-service-types/static-1.3766",
      "upgrade-management-service-types": "/upgrade-management-service-types/static-1.3750",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.13616",
      "seo-tools-lib": "/seo-tools-lib/static-1.5439",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "browser-eslint": "/browser-eslint/static-2.57",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3257",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.5836",
      "persist-promise": "/persist-promise/static-1.2805",
      "hub-http-janus": "/hub-http-janus/static-1.660",
      "general-store": "/general-store/static-6.20",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.7412",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.358",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11477",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.18929",
      "social-insights-client-types": "/social-insights-client-types/static-1.18609",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.14404",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.13276",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.15869",
      "marketplace-ui-details": "/marketplace-ui-details/static-1.5767",
      "property-management-iframe": "/property-management-iframe/static-1.9389",
      "trellis-ecosystem": "/trellis-ecosystem/static-1.5252",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.3770",
      "highcharts": "/highcharts/static-8.83",
      "report-customization-components": "/report-customization-components/static-1.9963",
      "reporting-action-components": "/reporting-action-components/static-1.37715",
      "reporting-data": "/reporting-data/static-1.63048",
      "reporting-enablement": "/reporting-enablement/static-1.18692",
      "reporting-snowflake": "/reporting-snowflake/static-1.51668",
      "reporting-visualizations": "/reporting-visualizations/static-1.55125",
      "reporting-plugins": "/reporting-plugins/static-1.7926",
      "reporting-reports": "/reporting-reports/static-1.62730",
      "customer-data-filters": "/customer-data-filters/static-1.49135",
      "highlight.js": "/highlight.js/static-1.45",
      "markdown-it": "/markdown-it/static-1.6",
      "react-table": "/react-table/static-1.15",
      "ui-addon-teams": "/ui-addon-teams/static-1.20211",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.10119",
      "calling-error-reporting": "/calling-error-reporting/static-1.30295",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.5549",
      "worker-connection-library": "/worker-connection-library/static-1.13717",
      "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.31618",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6420",
      "products-iframe-lib": "/products-iframe-lib/static-1.4514",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.7797",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.5257",
      "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.4356",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.7498",
      "fsm": "/fsm/static-1.2795",
      "policy-lib": "/policy-lib/static-1.5835",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.7560",
      "final-form": "/final-form/static-1.42",
      "academy-common-lib": "/academy-common-lib/static-1.10592",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2023",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.15871",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.7885",
      "crm_universal": "/crm_universal/static-1.20835",
      "customer-data-content": "/customer-data-content/static-1.25114",
      "crm_schema": "/crm_schema/static-3.87999",
      "customer-data-email": "/customer-data-email/static-1.16184",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.17753",
      "lodash": "/lodash/static-4.7",
      "customer-data-associations": "/customer-data-associations/static-1.6255",
      "customer-data-rte": "/customer-data-rte/static-1.30122",
      "cv-backend-services": "/cv-backend-services/static-1.1250",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.4403",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.14842",
      "prosemirror": "/prosemirror/static-1.13",
      "qrcode-generator": "/qrcode-generator/static-1.46",
      "quotes-client-types": "/quotes-client-types/static-1.33497",
      "trials-service-types": "/trials-service-types/static-1.3167",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6896",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.5692",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.9306",
      "immutable-less": "/immutable-less/static-1.3614",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7080",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3190",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.6270",
      "react-window": "/react-window/static-1.13",
      "ai-studio-lib": "/ai-studio-lib/static-1.7630",
      "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.15827",
      "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.10042",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.5206",
      "property-management-common": "/property-management-common/static-1.1675",
      "storybook-react": "/storybook-react/static-1.6",
      "trellis-story-utils": "/trellis-story-utils/static-1.3608",
      "dashboard-lib": "/dashboard-lib/static-1.77276",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.7723",
      "reporting-client-types": "/reporting-client-types/static-1.2077",
      "data-quality-ui-library": "/data-quality-ui-library/static-1.9497",
      "html-to-image": "/html-to-image/static-1.32",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.9362",
      "crm-object-map": "/crm-object-map/static-1.2837",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.4836",
      "deep-diff": "/deep-diff/static-1.5",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.31843",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.2964",
      "sales-views-client-types": "/sales-views-client-types/static-1.3373",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.2927",
      "academy-service-client": "/academy-service-client/static-1.2692",
      "zustand": "/zustand/static-1.51",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4205",
      "utility-belt": "/utility-belt/static-1.1592",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.39653",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.7566",
      "sequences-lib": "/sequences-lib/static-1.6353",
      "draft-content-plugins": "/draft-content-plugins/static-1.25475",
      "draft-convert": "/draft-convert/static-2.31",
      "draft-extend": "/draft-extend/static-2.46",
      "draft-js": "/draft-js/static-5.37",
      "draft-plugins": "/draft-plugins/static-2.19731",
      "knowledge-content-types": "/knowledge-content-types/static-1.7818",
      "stripe-connect-js": "/stripe-connect-js/static-1.42",
      "apps-service-types": "/apps-service-types/static-1.3121",
      "oauth-service-types": "/oauth-service-types/static-1.3347",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.12104",
      "crm-component-utils": "/crm-component-utils/static-1.35656",
      "redux-actions": "/redux-actions/static-3.7",
      "crm-fe-perf": "/crm-fe-perf/static-1.22048",
      "crm-index-visualization-object-layout": "/crm-index-visualization-object-layout/static-1.2041",
      "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.7016",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.35",
      "crm-actions": "/crm-actions/static-1.5139",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3365",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.6210",
      "card-properties-lib": "/card-properties-lib/static-1.40346",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.6742",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.42487",
      "enrichment-properties-lib": "/enrichment-properties-lib/static-1.11401",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.33422",
      "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.35613",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.50857",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.18379",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.14333",
      "project-storage": "/project-storage/static-1.3753",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.67414",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.4342",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.5350",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.52931",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.50873",
      "SafeStorage": "/SafeStorage/static-1.3445",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.98085",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.76128",
      "totals-ui-components": "/totals-ui-components/static-1.20336",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3046"
    },
    "project": "page-editor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};